// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"runtime": 0,
	"vendor": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(/^(apps_shells_bank\-web\-shell_src_(app_logout_logout_module|bootstrap)_ts|default\-(libs_shared_(u(i(\-(d(etails|ialog|rag\-and\-drop|ropdown)_src_index_ts|pa(gination|nel)_src_index_ts|t(a(b|ble|g)_src_index_ts|o(ast|oltip\-trigger)_src_index_ts)|((action\-shee|aler|lis)t|(butt|side\-navigati)on|badge|context\-menu|file\-upload|form\-controls|search\-control)_src_index_ts)|_src_index_ts)|til(\-(company\-info|events|search|total\-amount)_src_index_ts|_src_index_ts))|(domain\-logic|feature\-navigation\-bar)_src_index_ts)|node_modules_(a(ngular_(c(dk_fesm2022_(layout|overlay|portal|scrolling)_mjs|o(mmon_fesm2022_(common|http)_mjs|re_fesm2022_(effect|resource|rxjs\-interop)_mjs))|((platform\-browser_fesm2022_platform\-brows|router_fesm2022_rout)er|forms_fesm2022_forms)_mjs)|uth0_auth0\-angular_fesm2022_auth0\-auth0\-angular_mjs)|ngrx_(component\-store_fesm2022_ngrx\-component|store_fesm2022_ngrx)\-store_mjs|rxjs_dist_esm_internal_operators_auditTime_js\-node_modules_rxjs_dist_esm\-9f2bd5|tslib_tslib_es6_mjs))|libs_shared_ui\-(off\-canvas|title\-bar)_src_index_ts|node_modules_(a(ngular_core_fesm2022_(core|not_found)_mjs|uth0_auth0\-spa\-js_dist_auth0\-spa\-js_production_esm_js)|b((roadcast\-channel_dist_esbrowser|ufbuild_protobuf_dist_esm_wire)_index|ootstrap_dist_js_bootstrap_esm)_js|rxjs_dist_esm_(|operators_)index_js|((flowyourmoney_flow\-data\-frontend\-sdk_dist_src|graphql\-tag_lib|mathjs_lib_esm)_index|file\-saver_dist_FileSaver_min|microsoft_applicationinsights\-web_dist\-es5_applicationinsights\-web)_js)|common|main|polyfills|runtime|styles)$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkbank_web_shell"] = self["webpackChunkbank_web_shell"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));